import actionTypes from "../common/actionTypes";
import { DATABASE_STATUTES } from "../common/constants";

const sellingPlanReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SELLING_PLANS:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
        data: [],
      };

    case actionTypes.FETCH_SELLING_PLANS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.FETCH_SELLING_PLANS_FAILURE:
    case actionTypes.CREATE_PLAN_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.CREATE_PLAN:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.CREATE_PLAN_SUCCESS:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADED,
      };

    default:
      return state;
  }
};

export default sellingPlanReducer;
